// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactInfoModal_form__2OLkT","permissions":"ContactInfoModal_permissions__2ekIR","explanation":"ContactInfoModal_explanation__3yOYL"};